/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for Audio Play icon.
 *
 * @author Sai Haripriya Yerra
 */
const AudioPlay = props => (
  <SvgIcon viewBox="0 0 48 48" {...props}>
    <path
      d="M16 15a1.001 1.001 0 0 1 1.448-.894l18 9a1.002 1.002 0 0 1 0 1.788l-18 9a.995.995
      0 0 1-.974-.044A1.001 1.001 0 0 1 16 33V15zm8 33c13.234 0 24-10.766 24-24S37.234
      0 24 0 0 10.766 0 24s10.766 24 24 24z"
    />
  </SvgIcon>
);

export default AudioPlay;



// WEBPACK FOOTER //
// ./src/js/icons/AudioPlay.jsx